/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STICKY : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	sticky: {
		background: '#fff', // needed so elements passing behind this during scroll are hidden
        boxShadow: `0px -2px 4px 0px rgb(237, 241, 250)`,
        marginTop: pxToEm(150), // needed to prevent potential dropdowns not being able to fully display
        padding: replacePXinStringWithEM(`19px 0`),

        // force controls to bottom of the page always even when scrolling
        position: 'sticky',
    	bottom: '0',
    	left: '0',
    	zIndex: '11', // above the top most section of this page

    	opacity: '0',
		animationName: 'fadeInUp',
        animationDuration: '.2s',
        animationFillMode: 'forwards',
        animationDelay: '.4s',
	}
});